import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../../data-access/user.model';
import { UserManagementService } from '../../../data-access/user-management.service';
import {
  faCaretDown,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faEye,
  faClipboardUser,
  faRotateLeft,
  faXmark,
  faAdd
} from "@fortawesome/free-solid-svg-icons";
import {RoleService} from "../../../data-access/role.service";
import {AuthService} from "../../../../login/data-access/auth.service";
import {RoleInterface} from "../userRolesList/userRolesList.component";
import {RoleTempInterface} from "../../../../dashboard/userProfile/userProfile.component";
import {SubjectsModel} from "../../../data-access/subjects.model";
import {UnitsModel} from "../../../data-access/units.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Pagination} from "../../../../exam/feature/exam-submissions/exam-submissions.component";
import * as _ from "lodash";
import {APIResponse} from "../../../../shared/data-access/api-response.model";
import {Subscription} from "rxjs";
import {OrganizationsModel} from "../../../data-access/organizations.model";
import {Course} from "../../../data-access/course.model";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import {MenuItem} from "../../../../shared/ui/dropdown-menu/dropdown-menu.component";
interface RoleResponseInterface {
  role_name: string,
  role_id: string,
  subject_id: string,
  subject_name: string,
  unit_id: string,
  unit_name: string
  organization_id: string
  organization_name: string
  course_id: string
  course_name: string
}
interface UserResponseInterface {
  display_name: string
  roles: RoleResponseInterface[]
}
interface RoleScope {
  role_id: number
  organizations: OrganizationsModel[]
  subjects: SubjectsModel[]
  units: UnitsModel[]
  courses: Course[]
}
@Component({
    selector: 'userManagementList',
    templateUrl: './userManagementList.html',
    standalone: false
})
export class UserManagementListComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private usersService: UserManagementService,
    private authService: AuthService,
    private roleService: RoleService,
    private _snackBar: MatSnackBar
  ) {}
  faChevronRight = faChevronRight
  faCaretDown = faCaretDown
  faChevronLeft = faChevronLeft
  faChevronDown = faChevronDown
  faChevronUp = faChevronUp
  faXmark = faXmark
  users: User[] = []
  viewAllRoles = false
  viewAllRoleDetails: UserResponseInterface | null = null
  openAddRoleDialog = false;
  userRoles: RoleTempInterface[] = [];
  addedTempUserRole: RoleScope[] = [];
  subjectList: SubjectsModel[] = [];
  addedSubjectList: SubjectsModel[] = [];
  addedUnitList: UnitsModel[] = [];
  addedCourseList: Course[] = [];
  addedOrgList: OrganizationsModel[] = [];
  emailToAddRoleTo: string = '';
  currentPagination: Pagination = {
    limit: 25,
    size: 0,
    page: 0,
    start: 0,
    totalcount: 0,
    maxpage: 0
  }
  searchText = ''
  isLoading = false
  activateDeactivateConfirmationDialog = false
  activateDeactivateConfirmationUser: User | null = null
  canImpersonate = false
  showDeactivatedUsers = false
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement',
  }]

  ngOnInit() {
   this.handleServiceCall();
  }

  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    if(user && user.result.length > 0) {
      for (let permission of user.result) {
        if(permission.ui === 'ImpersonateUser') {
          this.canImpersonate = true
        }
      }
    }
  })

  profile(email: string) {
    this.router.navigate(['dashboard/profile'], {queryParams: {email: email}});
  }

  roleList(roles: string): string[] {
    return roles.split(',').map(role => role.trim()).filter(role => role.length > 0)
  }

  handleServiceCall() {
    this.isLoading = true
    this.usersService.listAllUsers(this.currentPagination.page, this.currentPagination.limit, !this.showDeactivatedUsers).subscribe((response) => {
      if(response.success) {
        this.handleSuccess(response)
      } else {
        this.isLoading = false
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  userManagementMenu() {
    this.router.navigate(['dashboard/UserManagement']);
  }

  addUser() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/AddNewUser']);
  }

  viewRolesClick(email: string) {
    this.viewAllRoles = true
    this.emailToAddRoleTo = email
    this.authService.getProfileDetails(email).subscribe((response) => {
      if(response.success)
        this.viewAllRoleDetails = response.result
    })
  }

  removeRole(role: RoleResponseInterface) {
    let subjects: SubjectsModel[] = []
    let units: UnitsModel[] = []
    let course: Course[] = []
    let orgs: OrganizationsModel[] = []
    if(role.subject_id != null)
      subjects = [{
        name: '',
        subject_id: role.subject_id
      }]
    if(role.unit_id != null)
      units = [{
        name: '',
        unit_id: role.unit_id
      }]
    if(role.organization_id != null)
      orgs = [{
        name: '',
        organization_id: role.organization_id
      }]
    if(role.course_id != null)
      course = [{
        name: '',
        course_id: Number(role.course_id),
        unit_id: '',
        start: new Date(),
        end: new Date()
      }]
    this.roleService.assignOrRemoveRole(this.emailToAddRoleTo, role.role_id, subjects, units, orgs, course, true).subscribe((response) => {
      if(response) {
        this.handleServiceCall();
        this._snackBar.open('Role successfully removed', 'Dismiss', {duration: 3000})
        this.closeRoleDetails()
      } else {
        this._snackBar.open('Failed to remove role', 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  closeRoleDetails() {
    this.viewAllRoles = false
    this.viewAllRoleDetails = null
  }

  removeItemFromList(item: any, list: any[]) {
    return list.filter(e => JSON.stringify(e) !== JSON.stringify(item));
  }

  cancelAddRole() {
    this.addedTempUserRole = []
    this.addedSubjectList = []
    this.addedUnitList = []
    this.emailToAddRoleTo = ''
    this.openAddRoleDialog = false
  }

  openAssignRoleDialog(email: string) {
    this.openAddRoleDialog = true
    this.emailToAddRoleTo = email
    this.roleService.listAllUserRoles().subscribe((response) => {
      if(response.success)
        this.userRoles = response.items
    })
  }

  saveNewRole() {
    if(this.addedTempUserRole.length !== 0)
      this.roleService.assignOrRemoveRole(this.emailToAddRoleTo, this.addedTempUserRole[0].role_id.toString(), this.addedSubjectList, this.addedUnitList, this.addedOrgList, this.addedCourseList, false).subscribe((response) => {
        if(response) {
          this.handleServiceCall();
          this._snackBar.open('Role successfully added', 'Dismiss', {duration: 3000})
          this.cancelAddRole()
        } else {
          this._snackBar.open('Failed to add role', 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
  }

  debounceSearch = _.debounce(() => {
    this.isLoading = true
    this.usersService.searchUsers(this.searchText, 0, this.currentPagination.limit).subscribe((response) => {
      if(response.success) {
        this.handleSuccess(response)
      } else {
        this.isLoading = false
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }, 500)

  handleSuccess(response: APIResponse) {
    this.currentPagination = {
      limit: response.result.limit,
      size: response.result.size,
      page: response.result.page,
      start: response.result.start,
      totalcount: response.result.totalcount,
      maxpage: Math.floor(response.result.totalcount / response.result.limit)
    }
    this.users = []
    for(let user of response.result.items) {
      const menuItems: MenuItem[] = [{
        title: 'Profile',
        action: () => this.profile(user.email)
      }, {
        title: 'View Roles',
        action: () => this.viewRolesClick(user.email)
      }, {
        title: 'Assign Role',
        action: () => this.openAssignRoleDialog(user.email)
      }, {
        title: 'View Instances',
        action: () => {
          this.router.navigate(['dashboard/UserManagement/instances'], {queryParams: {user_id: user.user_id}});
        }
      }]
      if(this.canImpersonate) {
        menuItems.push({
          // TODO need to check permissions for this item
          title: 'Impersonate',
          action: () => {
            localStorage.setItem('__OVERRIDE_USER', user.user_id)
            this._snackBar.open('User impersonation set, will refresh in 3 seconds', 'Dismiss', {duration: 3000})
            setTimeout(() => {
              location.reload()
            }, 3000)
          }
        })
      }
      // destructive action kept last, behind a divider, so it's harder to hit by accident
      menuItems.push({
        title: `${user.active? 'Deactivate': 'Activate'}`,
        danger: user.active,
        divider: true,
        action: () => {
          this.activateDeactivateConfirmationDialog = true
          this.activateDeactivateConfirmationUser = user
        }
      })
      this.users.push({...user, menuItems})
    }
    this.isLoading = false
  }

  setActive(user_id: number, active: boolean) {
    this.usersService.setActiveUser(user_id, active).subscribe((response) => {
      if(response.success) {
        if(active)
          this._snackBar.open('User successfully activated', 'Dismiss', {duration: 3000})
        else
          this._snackBar.open('User successfully deactivated', 'Dismiss', {duration: 3000})
        this.activateDeactivateConfirmationDialog = false
        this.activateDeactivateConfirmationUser = null
        this.handleServiceCall()
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  ngOnDestroy(): void {
    this.userPermissionSub.unsubscribe();
  }

  toggleDeactivatedUsers() {
    this.showDeactivatedUsers = !this.showDeactivatedUsers
    this.handleServiceCall()
  }

  protected readonly faAdd = faAdd;
}
